export default __webpack_public_path__ + "static/Corporate_Responsibility_ReponsibleSourcing_14-3a61ec0f02f6b3a24e054bd81400a685.jpg";